
import React from 'react';
import { ShieldCheck, Globe, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HomeWhySwitch = () => {
  const { t } = useTranslation('whySwitch');
  
  const reasons = [
    {
      icon: <ShieldCheck className="h-12 w-12 text-frikopplad-burgundy" />,
      title: t('home.reasons.0.title'),
      description: t('home.reasons.0.description')
    },
    {
      icon: <Globe className="h-12 w-12 text-frikopplad-burgundy" />,
      title: t('home.reasons.1.title'),
      description: t('home.reasons.1.description')
    },
    {
      icon: <Shield className="h-12 w-12 text-frikopplad-burgundy" />,
      title: t('home.reasons.2.title'),
      description: t('home.reasons.2.description')
    }
  ];

  return (
    <section className="bg-white" id="why-switch">
      <div className="container-custom section">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-frikopplad-navy mb-4">{t('home.title')}</h2>
          <p className="text-lg text-frikopplad-navy/80 max-w-3xl mx-auto">
            {t('home.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="mb-6">{reason.icon}</div>
              <h3 className="text-xl font-bold text-frikopplad-navy mb-3">{reason.title}</h3>
              <p className="text-frikopplad-navy/80">{reason.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 p-6 md:p-10 bg-frikopplad-cream rounded-xl">
          <div className="flex flex-col md:flex-row items-center">
            <div className="w-full md:w-2/3 mb-6 md:mb-0 md:mr-8">
              <h3 className="text-2xl font-bold text-frikopplad-navy mb-3">{t('home.cta.title')}</h3>
              <p className="text-frikopplad-navy/80">
                {t('home.cta.description')}
              </p>
            </div>
            <div className="w-full md:w-1/3 flex justify-center md:justify-end">
              <Link to="/paket" className="btn-primary w-full md:w-auto">
                {t('home.cta.button')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeWhySwitch;
